/** Contratos da administracao de repositorios git do Smart Review. */
export interface SmartReviewRepository {
  id: number;
  slug: string;
  provider: string;
  externalId: string;
  areaId?: string;
  org?: string;
  project?: string;
  name: string;
  defaultBranch?: string;
  enabled: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface RepositoryListResponse {
  repositories?: SmartReviewRepository[];
  /** Quantos cadastrados casam com o filtro — não quantos vieram na página. */
  total?: number;
}

/** Recorte da listagem de administração, aplicado no servidor. */
export interface RepositoryListParams {
  q?: string;
  status?: '' | 'enabled' | 'disabled';
  areaId?: string;
  limit?: number;
  offset?: number;
}

export interface RepositoryPage {
  items: SmartReviewRepository[];
  total: number;
}

export interface CreateRepositoryRequest {
  provider: string;
  /**
   * Identificador do repositório no provedor.
   *
   * Obrigatório só no Azure DevOps, onde é um GUID e o adapter endereça por ele. Nos
   * demais o backend o deriva de org/nome quando omitido.
   */
  externalId?: string;
  org?: string;
  project?: string;
  name: string;
  defaultBranch?: string;
  areaId?: string;
}

export interface UpdateRepositoryRequest {
  defaultBranch?: string;
  areaId?: string;
  enabled?: boolean;
}
